import { render, staticRenderFns } from "./LegacyPortfolioSelect.vue?vue&type=template&id=e73e20a8&scoped=true&"
import script from "./LegacyPortfolioSelect.vue?vue&type=script&lang=js&"
export * from "./LegacyPortfolioSelect.vue?vue&type=script&lang=js&"
import style0 from "./LegacyPortfolioSelect.vue?vue&type=style&index=0&id=e73e20a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73e20a8",
  null
  
)

export default component.exports